import { useContext } from 'react';

import { WorkspaceResourcesContext } from '@/contexts';

export const useWorkspaceResources = (): [Record<any, any>, (session: Record<any, any>) => void] => {
    const [resourcesCount, setResourcesCount] = useContext(WorkspaceResourcesContext);

    return [resourcesCount, setResourcesCount];
};
